export class StatisticsCriteria {
  companyId?: string;
  year?: string;
  monthYear?: string;
  department?: string;
  offer?: string;
  contractType?: string;
  selectedJobOwner?: string[];
}
export class AgeGroup {
  ageGroup?: string;
  count?: number;
}

export class GenderGroup {
  genderGroup?: string;
  percentage?: number;
}

export class GeographicalGroup {
  countryName?: string;
  countryCode?: string;
  population?: number;
}

export class OfferStatusGroup {
  label?: string;
  percentage?: number;
  count?: number;
}

export class OfferAcceptanceRate {
  accepted?: number;
  proposed?: number;
}

export class MonthlyRecruitmentCarriedOut {
  month?: string;
  carriedOut?: number;
  goal?: number;
}

export class OfferStatusStructure {
  structure?: string;
  completed?: number;
  inProgress?: number;
  notPublished?: number;
  acceptanceRate?: number;
}

export class ColumnChart {
  structure?: string;
  value?: number;
}

export class DoughnutChartObject {
  x?: string | number;
  y?: string | number;
  text?: string;
  color?: string;
}

export class AverageRecruitmentDelayResult {
  structure?: string;
  avgDelay?: number;
  count?: number;
}

export class MapCountryData {
  code?: string;
  name?: string;
  population?: number;
}

export class GenderChartData {
  type?: string;
  women?: number;
  men?: number;
  notSpecified?: number;
}
